'use client';

import { Box, SxProps, Theme } from '@mui/material';
import { useRouter } from '@peerless/ui-locale';
import { PrefetchKind } from 'next/dist/client/components/router-reducer/router-reducer-types';
import { useEffect, useRef } from 'react';

export function FinderContainer() {
  const router = useRouter();

  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (ref.current) {
      try {
        return prefetchListItems(router, ref.current);
      } catch (e) {
        console.error('Error in prefetchListItems:', e);
      }
    }
  }, [router]);

  return <Box id="selectorDiv" sx={style} ref={ref} />;
}

const style: SxProps<Theme> = {
  // use a selector which has higher priority than the etilize selectors
  '&.etilize-spex-selector#selectorDiv': {
    fontFamily: theme => theme.typography.fontFamily,

    '.icon-filter-panel': {
      color: theme => theme.palette.primary.main,
    },

    '.selected .check': {
      backgroundColor: theme => theme.palette.primary.main,
    },
  },
  '&.etilize-spex-selector .item .col-description .description p': {
    display: 'none',
  },
  '&.etilize-spex-selector .item .msrp': {
    display: 'none !important',
  },
};

function prefetchListItems(router: ReturnType<typeof useRouter>, container: HTMLDivElement) {
  const prefetchSet = new Set<string>();
  function prefetch(sku: string) {
    if (!prefetchSet.has(sku)) {
      prefetchSet.add(sku);
      router.prefetch(`/products/${sku}`, { kind: PrefetchKind.FULL });
    }
  }

  // use a dom mutation observer to intercept the list items
  const observer = new MutationObserver(mutations => {
    for (const mutation of mutations) {
      if (
        mutation.type === 'childList' &&
        (mutation.target as HTMLElement).classList.contains('item-list')
      ) {
        // only prefetch the first 4 items
        const items = Array.from(container.querySelectorAll('.sku')).slice(0, 4);

        // get the last text node in the item sku label as the sku
        const skus = items.flatMap(item =>
          [
            Array.from(item.childNodes)
              .filter(node => node.nodeType === Node.TEXT_NODE)
              .at(-1)?.textContent,
          ].filter(Boolean)
        );

        for (const sku of skus) {
          if (sku) {
            prefetch(sku);
          }
        }
      }
    }
  });

  observer.observe(container, { childList: true, subtree: true });

  return () => {
    observer.disconnect();
  };
}
